import { render, staticRenderFns } from "./OrderListPublic.vue?vue&type=template&id=4b901e31&"
import script from "./OrderListPublic.vue?vue&type=script&lang=js&"
export * from "./OrderListPublic.vue?vue&type=script&lang=js&"
import style0 from "./OrderListPublic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports